
import storeHelpers from './helpers'

export const wheels = {
  namespaced: true,
  state: {
    wheels: {},
    wheelsSubscription: null,
  },
  getters: {
    referenceFrontWheelByGroup: (state) => (group) => {
      return Object.entries(state.wheels).filter(([id, wheel]) => wheel.front_wheel).map(([id, wheel]) => {return {id: id, ...wheel}}).find(wheel => wheel.is_reference && wheel.group === group)
    },
    referenceRearWheelByGroup: (state) => (group) => {
      return Object.entries(state.wheels).filter(([id, wheel]) => !wheel.front_wheel).map(([id, wheel]) => {return {id: id, ...wheel}}).find(wheel => wheel.is_reference && wheel.group === group)
    }
  },
  mutations: {
    setWheelsById (state, data) {
      storeHelpers.setNameById(state, data, 'wheels')
    },
    setWheelsSubscription (state, data) {
      storeHelpers.setNameSubscription(state, data, 'wheels')
    },
  },
  actions: {
    subscribeWheels ({ commit, state }) {
      storeHelpers.subscribeByName(commit, state, 'wheels')
    },  
    unsubscribeWheels ({ commit, state }) {
      storeHelpers.unsubscribeByName(commit, state, 'wheels')
    }
  }
}
